// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#training {\n  height: 100%;\n}\n#training .category-error {\n  color: #f56c6c;\n  font-size: 12px;\n  line-height: 1;\n  padding-top: 4px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n}", ""]);
// Exports
module.exports = exports;
